/* global Turbo */
import '../../css/styleguide_v2.scss'
import '../../css/tailwind.css'
import initReactComponents from '../../application/v2_react_components'
import setAccordions from '../../src/accordions'
import setBreadcrumbsScrollPosition from '../../src/breadcrumbs'
import setTruncatedSections from '../../src/truncatedSections'
import { setEnquiryModal } from '../../src/enquiryModal'
import customRadioButtons from '../../src/customRadioButtons'
import customCheckboxButtons from '../../src/customCheckboxButtons'
import initCustomSelects from '../../src/customSelect'
import initCountDownTimers from '../../src/countDownTimers'
import { setModals } from '../../src/modals'
import closeNotificationsOnClick from '../../src/notifications'
import closePostRegModalOnSubmit from '../../src/postRegModal'

import initNavBarMenus from '../../src/navBarMenus'
import newsLetterSignUp from '../../src/newsLetterSignUp'
import initMobile from '../../libs/navbar/mobile'
import searchAutoComplete from '../../src/algolia_search/searchAutocomplete'

import setItemConfirmationForm from '../../src/itemConfirmationForm'
import lineItemConfirmationFormValidation from '../../src/form_validations/lineItemConfirmationFormValidation'
import reviewFormValidation from '../../src/form_validations/reviewFormValidation'

import setDispatchForm from '../../src/itemDispatchForm'
import itemDispatchFormValidation from '../../src/form_validations/itemDispatchFormValidation'

import signUpEmailValidation from '../../src/form_validations/signUpEmailValidation'
import initAnalytics from '../../src/analytics'
import initSentry from '../../libs/sentry'
import initPurchaseThankYou from '../../libs/purchase/thankyou'

import initLandingSurveyModal from '../../src/landingSurveyModal'
import initStyleQuiz from '../../src/stylequiz'
import initStyleQuizEntryModal from '../../src/styleQuizEntryModal'
import { initFooterCurrencySwitcher } from '../../utils/footerCurrencySwitcher'
import initFooterLocaleSwitcher from '../../src/footerLocaleSwitcher'
import initSellerReviews from '../../src/sellerReviews'
import initArticleProductCarousels from '../../src/articleProductCarousels'
import initLocaleSelectorModal from '../../src/localeSelectorModal'
import initAdminEnquiryModeration from '../../src/adminEnquiryModeration'
import initVeraInstantDiscovery from '../../src/vera/instant_discovery'

import startRailsUjs from '../../utils/startRailsUjs'
import '@hotwired/turbo-rails'

Turbo.session.drive = false
Turbo.config.forms.mode = 'optin'

require.context('../../images', true)

startRailsUjs()

initReactComponents()

document.addEventListener('DOMContentLoaded', () => {
  initSentry()
  initAnalytics()
  initAdminEnquiryModeration()
  setAccordions()
  setBreadcrumbsScrollPosition()
  setTruncatedSections()
  setEnquiryModal()
  customRadioButtons()
  customCheckboxButtons()
  initCustomSelects()
  setModals()
  closeNotificationsOnClick()
  newsLetterSignUp()
  initNavBarMenus()
  searchAutoComplete()
  initMobile()
  setItemConfirmationForm()
  lineItemConfirmationFormValidation()
  reviewFormValidation()
  setDispatchForm()
  itemDispatchFormValidation()
  signUpEmailValidation()
  initPurchaseThankYou()
  closePostRegModalOnSubmit()
  initLandingSurveyModal()
  initStyleQuiz()
  initStyleQuizEntryModal()
  initFooterCurrencySwitcher()
  initFooterLocaleSwitcher()
  initSellerReviews()
  initArticleProductCarousels()
  initLocaleSelectorModal()
  initVeraInstantDiscovery()

  import(/* webpackChunkName: "carousels" */ '../../src/carousels').then(module => {
    module.initTopBannerCarousel()
    initCountDownTimers()
  })

  window.initCustomSelects = initCustomSelects
  window.setAccordions = setAccordions
})
